export default "__VITE_ASSET__24VXNVTY__"